module.exports = "/static/assets/de6a2ca491eb20b2b669e732e84ce7af.png";